import { AstrologyButton, AstrologyButtonOption  } from "./style";

export const ButtonAstrology = ({href = "#" , label = "", children, className = "", liClassName = ""}) => {
  return (
      <AstrologyButton className={liClassName}>
        <h3>
          <a
            href={href}
            target="_self"
            aria-label={label}
            className={`astrology-today ${className}`}
          >
            {children}
          </a>
        </h3>
      </AstrologyButton>
  );
};

export const ButtonAstrologyOption = ({href = "#" , label = "", children, className = "", liClassName = ""}) => {
  return (
      <AstrologyButtonOption className={liClassName}>
        <h3>
          <a
            href={href}
            target="_self"
            aria-label={label}
            className={`astrology-today ${className}`}
          >
            {children}
          </a>
        </h3>
      </AstrologyButtonOption>
  );
};